export const formatLeadsData = (leadsData = []) => {
  return leadsData.map((row) => ({
    id: row._id, // Ensure every row has a unique id
    leadName: row.productInterested?.name,
    category: row.productInterested?.name,
    ofCompany: row.ofCompany,
    createdAt: row.createdTime,
    updatedAt: row.lastActivityDate,
    compaignName: row.compaignName || "N/A",
    leadSource: row.leadSource || "N/A",
    name: `${row.firstName} ${row.lastName}`,
    firstName: row.firstName,
    lastName: row.lastName,
    mobile: row.mobile,
    email: row.email,
    currentStatus: row.currentStatus?.name,
    currentStatusColor: row.currentStatus?.color,
    assignedTo: row?.assignedTo?.name,
    assignedToId: row.assignedTo?._id,
    description: row.description || "N/A",
    city: row.address?.city || row?.city || "N/A",
    state: row.address?.state || row?.state || "N/A",
    referenceSource: row.referenceSource || "N/A",
    probability: row.probability || "medium",
    isDuplicate: row?.duplicate || false,
    duplicateCount: row?.duplicateCount,
    createdTime: row.createdTime,
    lastActivityDate: row.lastActivityDate,
    zoomMeetingStatus: row.meetingStatus,
    zoomMeetingDuration: row?.meetingDetails?.duration,
    zoomMeetingDetails: row?.meetingDetails,
    productName: row.productInterested?.name,
    language: row.language || "N/A",
  }));
};

export const formatDealsData = (dealsData = []) => {
  return dealsData.map((row) => ({
    id: row._id, // Ensure every row has a unique id
    ofCompany: row.ofCompany,
    createdAt: row.leadToDealOn,
    updatedAt: row.lastActivityDate,
    compaignName: row.compaignName || "N/A",
    leadSource: row.leadSource || "N/A",
    name: `${row.firstName} ${row.lastName}`,
    firstName: row.firstName,
    lastName: row.lastName,
    mobile: row.mobile,
    email: row.email,
    currentStatus: row.currentStatus?.name,
    currentStatusColor: row.currentStatus?.color,
    assignedTo: row?.assignedTo?.name,
    assignedToId: row.assignedTo?._id,
    description: row.description || "N/A",
    city: row.address?.city || row?.city || "N/A",
    state: row.address?.state || row?.state || "N/A",
    referenceSource: row.referenceSource || "N/A",
    probability: row.probability || "medium",
    paymentStatus: row.paymentDetails?.totalPaymentVerified || "N/A",
    createdTime: row.leadToDealOn,
    lastActivityDate: row.lastActivityDate,
    zoomMeetingStatus: row.meetingStatus,
    zoomMeetingDuration: row?.meetingDetails?.duration,
    zoomMeetingDetails: row?.meetingDetails,
    leadCreatedTime: row?.createdTime,
    productName: row.productInterested?.name,
    language: row.language || "N/A",
  }));
};

export const formatUsersData = (usersData = []) => {
  return usersData.map((row) => ({
    id: row?._id, // Ensure every row has a unique id
    ofCompany: row.ofCompany?.name,
    name: row.name,
    mobile: row.mobile,
    email: row.email,
    role: row?.role?.name,
    roleId: row.role?._id,
    status: row.status,
    createdAt: row.createdAt,
    updatedAt: row.updatedAt,
  }));
};

export const formatAccountsData = (accountsData = []) => {
  return accountsData.map((row) => ({
    id: row._id, // Ensure every row has a unique id
    name: `${row.firstName} ${row.lastName}`,
    firstName: row.firstName,
    lastName: row.lastName,
    mobile: row.mobile,
    email: row.email,
    ofCompany: row?.ofCompany?.name,
    createdAt: row.createdAt,
    updatedAt: row.updatedAt,
  }));
};

export const formatEnrollmentData = (leadsData = []) => {
  return leadsData.map((row) => ({
    id: row._id,
    enrolledOn: row.enrolledOn,
    updatedAt: row.lastActivityDate,
    compaignName: row.compaignName || "N/A",
    leadSource: row.leadSource || "N/A",
    fullName: row.fullName || "N/A",
    email: row.email || "N/A",
    mobile: row.mobile || "N/A",
    course: row.course || "N/A",
    medium: row.medium || "N/A",
    informationCallDate: row.informationCallDate,
    joiningProcessCallDate: row.joiningProcessCallDate,
    serviceFirstCallOn: row.serviceFirstCallOn,
    serviceSecondCallOn: row.serviceSecondCallOn,
    serviceThirdCallOn: row.serviceThirdCallOn,
    assignedTo: row?.assignedTo?.name,
    lastActivityDate: row.lastActivityDate,
  }));
};
export const formatProfilingData = (profilingData = []) => {
  return profilingData.map((row) => ({
    id: row._id,
    isInEnrollment: row?.isInEnrollment,
    fullName: row?.clientDetails?.fullName || "N/A",
    email: row?.email || "N/A",
    mobile: row?.mobile || "N/A",
    isCompleted: row?.profilingformStatus?.isCompleted || false,
    submittedOn: row?.submittedOn,
  }));
};
